import { Action } from 'redux';
import { StateObservable, combineEpics } from 'redux-observable';
import {
  of, concat, Observable, flatMap, filter,
} from 'rxjs';

import { lobbyActions, menuActions } from '../../actions';
import { lobbyOpenMenuWidgetSelector } from '../../selectors/lobby';

import type { RootState } from '../../../store/types';

const { lobby } = lobbyActions;
const { menu } = menuActions;

const noAction = (): Action => ({ type: 'NO_ACTION' });

const openMiniLobbyEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>
): Observable<Action> => action$.pipe(
  filter(lobby.open.match),
  flatMap(() => {
    const isLobbyOpenAsMenu = lobbyOpenMenuWidgetSelector(state$.value);
    if (isLobbyOpenAsMenu) {
      return concat(
        of(lobby.patch({ openMenuWidget: false })),
        of(menu.set({ open: false, widget: { drawer: false } }))
      );
    }

    return of(noAction());
  }),
);

const closeMenuEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>
): Observable<Action> => action$.pipe(
  filter(menu.set.match),
  flatMap(() => {
    const isLobbyOpenAsMenu = lobbyOpenMenuWidgetSelector(state$.value);
    if (isLobbyOpenAsMenu) {
      return of(lobby.close());
    }
    return of(noAction());
  }),
);

export default combineEpics(openMiniLobbyEpic, closeMenuEpic);
